import { Link, useLocation } from 'react-router-dom';
import { Building2, LayoutDashboard, Calendar, Umbrella, LogOut, Users } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = ({ user, onLogout }) => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const employeeLinks = [
    { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/leaves', label: 'Leaves', icon: Calendar },
    { path: '/holiday-tracker', label: 'Holiday Tracker', icon: Umbrella },
  ];

  const adminLinks = [
    { path: '/admin', label: 'Admin Dashboard', icon: Users },
  ];

  const links = user?.role === 'admin' ? adminLinks : employeeLinks;

  return (
    <nav className="bg-white border-b border-slate-200 shadow-sm" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-4 sm:space-x-8">
            <Link to={user?.role === 'admin' ? '/admin' : '/dashboard'} className="flex items-center space-x-2">
              <Building2 className="h-6 w-6 text-primary" strokeWidth={1.5} />
              <span className="text-lg sm:text-xl font-bold font-heading">S.N. Randar</span>
            </Link>

            <div className="flex space-x-1">
              {links.map((link) => {
                const Icon = link.icon;
                return (
                  <Link
                    key={link.path}
                    to={link.path}
                    data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
                    className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-3 py-2 rounded-md text-xs sm:text-sm font-medium transition-colors ${
                      isActive(link.path)
                        ? 'bg-accent text-accent-foreground'
                        : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    <span className="hidden sm:inline">{link.label}</span>
                  </Link>
                );
              })}
            </div>
          </div>

          <div className="flex items-center space-x-2 sm:space-x-4">
            <div className="text-right hidden lg:block">
              <p className="text-sm font-medium">{user?.name}</p>
              <p className="text-xs text-muted-foreground capitalize">{user?.role}</p>
            </div>
            <Button data-testid="logout-button" onClick={onLogout} variant="outline" size="sm">
              <LogOut className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">Logout</span>
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;